import axiosClient from "./axiosClient";

const url = "/announcements";

export const announcementApi = {
  getAll(params) {
    return axiosClient.get(url, { params });
  },
  getById(id) {
    return axiosClient.get(`${url}/${id}`);
  },
  getBySlug(slug) {
    return axiosClient.get(`${url}/slug/${slug}`);
  },
  create(body) {
    return axiosClient.post(url, body, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },
  update(id, body) {
    return axiosClient.put(`${url}/${id}`, body, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },
  remove(id) {
    return axiosClient.delete(`${url}/${id}`);
  },
  togglePin(id) {
    return axiosClient.put(`${url}/${id}/pin`);
  },
};
